// Constants
import { APP_CONFIG } from "../constants";

// Helpers
import { isWeb, loadPageInit, isMobileWeb } from '../helpers';


export const RoutesValidator = {

    /**
     * Valida los ingresos incorrectos dentro de la página QrScan y en caso de un flujo indebido,
     * redirecciona a donde corresponde
     * @param { Object } history Objeto history del routes
     * @param { Object } pageConfig Configuración de la página que se extrae de APP_CONFIG.PAGE
     */
    validatePageQrScan: (history, pageConfig) => {

        // Si la aplicación se está usando desde un browser, se redirige al flujo de DNI
        if ( isWeb() || isMobileWeb() ) { 
            
            history.push(pageConfig.platformRedirectPage);
            return false;
        }

        return true;
    },

    /**
     * Valida los ingresos incorrectos dentro de la página Benefits y en caso de un flujo indebido,
     * redirecciona a donde corresponde
     * @param { Object } benefits Listado de beneficios que se extraen de redux benefit.list
     * @param { Object } history Objeto history del routes
     */
    validatePageBenefit: (benefits, history) => {

        if (benefits === undefined ||
            benefits.length <= APP_CONFIG.PAGES.BENEFIT.validate.benefitsLength) { 
            
            const pagePrev = loadPageInit();
            history.push(pagePrev);
            return false;
        }
    },

    /**
     * Valida los ingresos incorrectos dentro de la página Detail y en caso de un flujo indebido,
     * redirecciona a donde corresponde
     * @param { Object } transaction Información de la transacción en curso que se extrae de redux transaction.activated
     * @param { Object } history Objeto history del routes
     */
    validatePageDetail: (transaction, history) => {
        
        if ( transaction.transactionId === APP_CONFIG.PAGES.DETAIL.validate.transactionId ||
            !transaction || !transaction.transactionId) { 

            const pagePrev = loadPageInit();
            history.push(pagePrev);
            return false;
        }

        return true;
    }
};